// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3v__0","logo-wrapper":"Footer_logo-wrapper__Yhl_e"};